import './App.css';
import { BrowserRouter, Route, Routes, useNavigate } from 'react-router-dom'
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Dashboard from '../src/Pages/Dashboard/Dashboard'
import UserManage from '../src/Pages/UserManage/UserManage.js'
import CreateUser from '../src/Pages/CreateUser/CreateUser.js'
import UpdateProfile from '../src/Pages/UpdateProfile/UpdateProfile.js'
import UpdateUser from '../src/Pages/UpdateUser/UpdateUser.js'
import ChangePassword from '../src/Pages/ChangePassword/ChangePassword.js'
import Profile from '../src/Pages/Profile/Profile.js'

import FileUpload from './Pages/FileMangement/FileUpload.js'
import FileManegment from './Pages/FileMangement/FileManagement.js'
import StudentsApplication from './Pages/FileMangement/StudentsApplication.js'
import AsignedApplications from './Pages/FileMangement/AsignedApplications.js'
import StudentUpdate from './Pages/FileMangement/StudentUpdate.js'
import StudentDetails from './Pages/FileMangement/StudentDetails.js'
import StudentAsign from './Pages/FileMangement/StudentAsign.js'
 
import Login from '../src/Pages/login/Login'

import InvitedUser from '../src/Pages/InvitedUser/InvitedUser.js'
import InviteForgetPassword from '../src/Pages/InviteForgetPassword/InviteForgetPassword.js'
// import { Link, useNavigate } from "react-router-dom";

import Register from '../src/Pages/register/Register'
import ForgetPassword from '../src/Pages/ForgetPassword/ForgetPassword.js'
import NoPage from '../src/Pages/NoPage/NoPage'
import Header from '../src/components/Header/header.js'
import Footer from '../src/components/Footer/Footer.js'
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loadUser } from './actions/userAction';


function App() {
  const [underLine, setUnderLine] = useState("");

  const {user, loading,isAuthenticated} = useSelector(state=>state.users)
  const dispatch = useDispatch();
  // const navigate = useNavigate();

  useEffect(() => {
    dispatch(loadUser())

    // if (!isAuthenticated) {
    //   navigate("/");
    //   }
      
  }, [dispatch]);



  // setUnderLine('home');

  return (
    <BrowserRouter>
      {/* <Header underLine={underLine}/> */}
      <Routes>
        <Route path='/password/reset/:token' element={<InviteForgetPassword setUnderLine={setUnderLine}  />} />
        <Route path='/' element={<Login setUnderLine={setUnderLine}  />} />
        <Route path='/email/invited-user/:token' element={<InvitedUser setUnderLine={setUnderLine}  />} />
        <Route path='/register' element={<Register setUnderLine={setUnderLine}  />} />
        <Route path='/forget/password' element={<ForgetPassword setUnderLine={setUnderLine}  />} />

        <Route path='/dashboard' element={<Dashboard setUnderLine={setUnderLine} underLine={underLine} />} /> 
        <Route path='/user' element={<UserManage setUnderLine={setUnderLine} underLine= {underLine}/>} />
         
        <Route path='/create-user' element={<CreateUser setUnderLine={setUnderLine}  />} />
        <Route path='/update/profile' element={<UpdateProfile setUnderLine={setUnderLine}  />} />
        <Route path='/user/update/:id' element={<UpdateUser setUnderLine={setUnderLine}  />} />
        <Route path='/change/password' element={<ChangePassword setUnderLine={setUnderLine}  />} />
        <Route path='/profile' element={<Profile setUnderLine={setUnderLine}  />} /> 

        <Route path='/file/management' element={<FileManegment setUnderLine={setUnderLine} underLine={underLine}  />} />
        <Route path='/student/application' element={<StudentsApplication setUnderLine={setUnderLine} underLine={underLine}  />} />
        <Route path='/asigned/applications' element={<AsignedApplications setUnderLine={setUnderLine} underLine={underLine} />} />

        <Route path='/file/upload' element={<FileUpload setUnderLine={setUnderLine}  />} />
        <Route path='/student/details/update/:id' element={<StudentUpdate setUnderLine={setUnderLine}  />} />
        <Route path='/student/details/:id' element={<StudentDetails setUnderLine={setUnderLine}  />} />
        <Route path='/student/asign/:id' element={<StudentAsign setUnderLine={setUnderLine}  />} />
        

        <Route path='*' element={<NoPage setUnderLine={setUnderLine}  />} />
      </Routes>
      <ToastContainer />
      <Footer />

    </BrowserRouter>
  );
}

export default App;
